import DataTable from "@/components/Common/DataTable";
import CommonTab from "@/components/Common/Tab";
import { TabMenu } from "@/types/Shared/tab";
import { useLocation, useNavigate } from "react-router-dom";
import { columns } from "./columns";
import { useReadProjectGroupsAll } from "@/libs/react-query/hooks/useProjectQuery";
import { useIsAdmin } from "@/hooks/useIsFinancialManager";
import { DEFAULT_PAGINATION } from "@/consts/common";

export default function ProjectManagement() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const tabData: TabMenu[] = [
    {
      label: "프로젝트 관리",
      path: "/management/projects",
    },
    {
      label: "작업 관리",
      path: "/management/tasks",
    },
  ];
  const isAdmin = useIsAdmin();

  const { data, isLoading } = useReadProjectGroupsAll({
    pagination: DEFAULT_PAGINATION,
  });

  const dataWithClickHandlers = data?.project_groups.map((item) => ({
    ...item,
    onRowClick: () => navigate(`/management/projects/${item.project_group_id}`),
    disabled: !isAdmin && !item.is_participating,
  }));

  if (isLoading) {
    return null;
  }

  return (
    <div>
      <CommonTab variants="string" data={tabData} state={state} />
      <div className="mt-5 bg-white border border-gray-D rounded-xl">
        <DataTable
          columns={columns}
          data={dataWithClickHandlers || []}
          isPagination={true}
        />
      </div>
    </div>
  );
}
